import { number, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const databaseSystemDefinedPropertiesType = {
  _ts: number,
  _rid: string,
  _self: string,
  _etag: string,
  _attachments: string,
};
